/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-05.
 * Main App Theme.
 */
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { lightBlue800 } from 'material-ui/styles/colors';

export const muiTheme = getMuiTheme({
  palette: {
    accent1Color: lightBlue800,
    primary1Color: lightBlue800,
    pickerHeaderColor: lightBlue800,
  },
});



// WEBPACK FOOTER //
// ./theme.js